export enum TypeRol {
  USER_ROLE = 'USER_ROLE',
  ADMIN_ROLE = 'ADMIN_ROLE',
  OPERATION_ROLE = 'OPERATION_ROLE',
  DEVELOPER = 'DEVELOPER',
}

export default TypeRol;
